@if (mode() === 'view') {
    <div class="o-grid">
        <!-- Flight input form variant: legacy form with only "Special requests" field visible; to display for pre-August-2023 requests -->
        @if (formGroup().value.travelType !== null && formGroup().value.departureDate === null) {
            <div class="o-grid__row">
                <div class="o-grid__item">
                    <div class="c-info__block">
                        <h5>Special requests</h5>
                        <span>{{ formGroup().controls.specialRequests.value ?? 'Unspecified' }}</span>
                    </div>
                </div>
            </div>
        }

        <!-- Flight input form variant: form with all fields visible -->
        @if (
            formGroup().value.travelType !== null &&
            formGroup().value.travelType !== TravelType.NO_FLIGHT &&
            formGroup().value.departureDate !== null
        ) {
            <div class="o-grid__row">
                <div class="o-grid__item">
                    <div class="c-info__block">
                        <h5>From airport</h5>
                        <span>{{ formGroup().controls.airportOrigin.value }}</span>
                    </div>
                </div>
                <div class="o-grid__item">
                    <div class="c-info__block">
                        <h5>To airport</h5>
                        <span>{{ formGroup().controls.airportDestination.value }}</span>
                    </div>
                </div>
            </div>
            <div class="o-grid__row">
                <div class="o-grid__item">
                    <div class="c-info__block">
                        <h5>Departure date</h5>
                        <span>{{ formGroup().controls.departureDate.value?.toDate() | dateFormat | uppercase }}</span>
                    </div>
                </div>
                @if (formGroup().value.travelType === TravelType.ROUND_TRIP) {
                    <div class="o-grid__item">
                        <div class="c-info__block">
                            <h5>Return date</h5>
                            <span>{{ formGroup().controls.returnDate.value?.toDate() | dateFormat | uppercase }}</span>
                        </div>
                    </div>
                }
            </div>
            <div class="o-grid__row">
                <div class="o-grid__item">
                    <div class="c-info__block">
                        <h5>Special requests</h5>
                        <span>{{ formGroup().controls.specialRequests.value ?? 'Unspecified' }}</span>
                    </div>
                </div>
            </div>
        }
    </div>
} @else if (mode() === 'edit' && { travelTypeChange: travelTypeChange$ | async }) {
    <div class="flex flex-col gap-medpace-field">
        @for (error of formGroup().errors | keyvalue; track error.key) {
            <medpace-alert [appearance]="'danger'" [content]="error.value" />
        }
        <div class="flex flex-col">
            <span class="pl-[0.6rem]">
                Choose flight type
                <span class="required-asterisk">*</span>
            </span>
            <mds-button-toggle-group
                [buttons]="flightOptionButtons()"
                [multiple]="false"
                [deselectable]="false"
                [formCtrl]="formGroup().controls.travelType"
            />
        </div>
        @if (formGroup().controls.travelType.hasError('required')) {
            <medpace-alert [appearance]="'danger'" [content]="'Please select a flight type'" />
        }
        @if (formGroup().value.travelType !== null && formGroup().value.travelType !== TravelType.NO_FLIGHT) {
            <div class="grid grid-cols-2 gap-medpace-field">
                <mds-autocomplete
                    id="airportOrigin"
                    [label]="'Airport (Origin)'"
                    [placeholder]="'Type here...'"
                    [appearance]="'outline'"
                    [options]="autocompleteOptions().airportOrigin"
                    [formCtrl]="formGroup().controls.airportOrigin"
                />
                <mds-autocomplete
                    id="airportDestination"
                    [label]="'Airport (Destination)'"
                    [placeholder]="'Type here...'"
                    [appearance]="'outline'"
                    [formCtrl]="formGroup().controls.airportDestination"
                    [options]="autocompleteOptions().airportDestination"
                />
                <medpace-datepicker
                    id="departureDate"
                    [label]="'Departure Date'"
                    [appearance]="'outline'"
                    [formCtrl]="formGroup().controls.departureDate"
                />
                @if (formGroup().value.travelType === TravelType.ROUND_TRIP) {
                    <medpace-datepicker
                        id="returnDate"
                        [label]="'Return Date'"
                        [appearance]="'outline'"
                        [formCtrl]="formGroup().controls.returnDate"
                    />
                }
            </div>
            <medpace-textarea-autocomplete
                id="specialRequests"
                [autoSize]="true"
                [cdkAutosizeMaxRows]="20"
                [cdkAutosizeMinRows]="5"
                [label]="'Special Requests'"
                [placeholder]="'Special requests - e.g. airline preference, seat preference'"
                [appearance]="'outline'"
                [formCtrl]="formGroup().controls.specialRequests"
                [options]="autocompleteOptions().specialRequests"
            />
        }
    </div>
}
